import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';

import { CloneService } from '../../../../../../services/clone.service';
import { UserSettingsService } from '../../../../../../services/members/user-settings.service';
import { ValidationMessageService } from '../../../../../../services/validation-message.service';

import { ComparisonValidatorsModule } from '../../../../../../directives/validators/comparison/comparison-validators.module';
import { EqualValidatorDirective } from '../../../../../../directives/validators/comparison/equal-validator.directive';
import { ErrorClassWhenInvalidModule } from '../../../../../../directives/error-class-when-invalid/error-class-when-invalid.module';
import { PasswordValidatorDirective } from '../../../../../../directives/validators/string/password-validator.directive';
import { StringValidatorsModule } from '../../../../../../directives/validators/string/string-validators.module';
import { TabbedViewChangerModule } from '../../../../shared/tab-changers/tabbed-view-changer/tabbed-view-changer.module';
import { Confirm2faCodeComponent } from './confirm-2fa-code.component';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        ComparisonValidatorsModule,
        ErrorClassWhenInvalidModule,
        StringValidatorsModule,
        TabbedViewChangerModule,
    ],
    declarations: [Confirm2faCodeComponent],
    exports: [Confirm2faCodeComponent],
    providers: [
        // Services
        CloneService,
        UserSettingsService,
        ValidationMessageService,
        // Directives
        EqualValidatorDirective,
        PasswordValidatorDirective,
    ],
})
export class Confirm2faCodeModule
{
}
